import { KeyInfoInterface } from '@/interfaces/KeyInfoInterface';
import { Component, Prop } from 'vue-property-decorator';
import AbstractFilterMultiple from '@/components/CustomFilter/AbstractFilterMultiple';
import { FilterInterface } from '@/components/CustomFilter/FilterInterface';

@Component
export default class AbstractFilterMultipleEnum extends AbstractFilterMultiple implements FilterInterface {

  // #region @Props

  @Prop()
  protected enum!: Record<string, string>;

  @Prop()
  protected enumKeyInfo!: Record<string, KeyInfoInterface>;

  // #endregion

  // #region API Requests

  protected async getItems(filter: string = '') {
    this.items = await this.$storage.remember<any[]>(`${this.filtersStorageKey}_${this.filterStorageKey}_${filter}`, async () => {
      this.items = Object.values(this.enum).map((key: any) => ({
        id: key,
        name: this.enumKeyInfo[key] && this.enumKeyInfo[key].labelShort ? this.enumKeyInfo[key].labelShort : key,
      }));

      return this.items;
    })
  }

  // #endregion
}
